export default ({ request }) => ({
  orderExpenseListApi(data = {}) {
    return request({
      url: '/factory/order/expense/list',
      method: 'post',
      data,
    })
  },
  orderExpenseSaveApi(data = {}) {
    return request({
      url: '/factory/order/expense/save',
      method: 'post',
      data,
    })
  },
  orderExpenseDetailApi(data = {}) {
    return request({
      url: '/factory/order/expense/detail',
      method: 'post',
      data,
    })
  },
  orderExpenseDelApi(data = {}) {
    return request({
      url: '/factory/order/expense/del',
      method: 'post',
      data,
    })
  },
  orderExpenseSubmitAuditApi(data = {}) {
    return request({
      url: '/factory/order/expense/submit',
      method: 'post',
      data,
    })
  },
  orderExpenseSubmitOaApplyApi(data = {}) {
    return request({
      url: '/oa/order/expense/apply',
      method: 'post',
      data,
    })
  },
  orderExpenseItemListApi(data = {}) {
    return request({
      url: '/factory/order/expense/item/list',
      method: 'post',
      data,
    })
  },
  orderExpenseDocistApi(data = {}) {
    return request({
      url: '/factory/order/expense/doc/list',
      method: 'post',
      data,
    })
  },
  //查询银行账户信息接口
  masterCustomerBankListApi(data = {}) {
    return request({
      url: '/digitalCenter/master/customer/bank/list',
      method: 'post',
      data,
    })
  },
  masterScmInfoBankListApi(data = {}) {
    return request({
      url: '/digitalCenter/scmInfo/bank/list',
      method: 'post',
      data,
    })
  },
})
